<h2 *ngIf="errorMessage$ | async as errorMessage">{{ errorMessage }}</h2>
<p *ngIf="errorMessage2$ | async as errorMessage2">{{ errorMessage2 }}</p>
